var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex flex-row" },
    [
      _c(
        "BaseInputDate",
        _vm._g(
          _vm._b(
            {
              attrs: { label: _vm.dateLabel, placeholder: _vm.datePlaceholder },
              model: {
                value: _vm.when.date,
                callback: function ($$v) {
                  _vm.$set(_vm.when, "date", $$v)
                },
                expression: "when.date",
              },
            },
            "BaseInputDate",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _c(
        "BaseInputTime",
        _vm._g(
          _vm._b(
            {
              attrs: { label: _vm.timeLabel, placeholder: _vm.timePlaceholder },
              model: {
                value: _vm.when.time,
                callback: function ($$v) {
                  _vm.$set(_vm.when, "time", $$v)
                },
                expression: "when.time",
              },
            },
            "BaseInputTime",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }